$(function() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = $('.blog-search-main form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = $(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();    
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=article&q=' + term;
      // What's the search results list?
      console.log(term)
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term != $(this).attr('data-old-term')) {
        // Saving old query.
        $(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          // resultsList.empty();
          // If we have no results.
          console.log(data);
          if(data.results_count == 0) {
            $('.default_container').show();
            $('.result_container').hide();
          } else {
            $('.default_container').hide();
            $('.result_container').show();
            // If we have results.
            $('.result_container_sec .blogModule-posts').html('');
            $('.result_container.result_container_first').html('');
            $('.result_container_sec,.result_container_first').hide();
            $.each(data.results, function(index, item) {
              if(index == 0){
                var html = '';
                    html +=  '<div class="article article--featured article--has-image flex flex-flow align-item-center">'
                    html +=    '<div class="article__content-left">'
                                +'<div class="article__content-left-inner">'+
                                '<p class="article__meta-f"></p><div class="flex align-item-center post__tags-featured"><span class="article__meta__date-home"><time pubdate="" datetime="'+item.datetime+'">'+item.published_at+'</time></span>'+'</div>' 
                                +'<h2 class="article__title heading-family"><a class="heading-family" href="'+item.url+'">'+item.title+'</a></h2>'
                                +'<p class="article__excerpt"><a href="'+item.url+'">'+item.title+'</a></p></div>'
                                
                    html +=     '</div>'
                    html +=    '<div class="article__image-container">'
                    html +=        '<a class="article__image" href="'+item.url+'" title="'+item.title+'"><div class="image-wrapper lazy-image lazy-image--backfill" ><img src="'+item.image+'"></div></a>'  
                    html +=      '</div>'
                    html +=  '</div>'
                    html += ''
                $('.result_container.result_container_first').html(html);
                $('.result_container_first').show();
              }else{
                var html = '';
                html += '<article class="blogModule-posts__post blogModule-posts__post-item block s1 med_s12 lg_s13 blogModule-posts__post--has-image boxinline" data-blog-post="">'
                html += '<div class="blogModule-posts__post-block"><a href="'+item.url+'" title="'+item.title+'" class="post__image">'+
                        '<div class="image-wrapper lazy-image lazy-image--backfill" style="--aspect-ratio: 1;"><img src="'+item.image+'"></div></a></div>'+
                        '<a href="'+item.url+'" title="'+item.title+'" class="article__info">'+
                        '<div class="article__meta"><span class="article__meta__date-home"><time datetime="'+item.datetime+'">'+item.published_at+'</time></span></div>'+
                        '<h3 class="article__title" data-post-title="">'+item.title+'</h3>' +
                        '<p class="article__excerpt" data-post-excerpt="">'+item.excerpt+'</p>'
                        '</a>'   
                         +'</article>'
                $('.result_container_sec .blogModule-posts').append(html);
               $('.result_container_sec').show();
              }
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 10) {
              // resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
            }
            // resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  $('body').bind('click', function(){
    $('.search-results').hide();
  });
 
});
